export const guestBackground = theme => ({})
